// covered-by: frontends/carrie/src/ask-v2/shell/__tests__/AskV2Layout.test.tsx
import { Outlet } from "@tanstack/react-router";

import { AskV2Sidebar } from "./AskV2Sidebar";

import { AskPunttDesktopNotificationsWatcher } from "../../components/AskPunttDesktopNotificationsWatcher";
import { AuthenticationDialog } from "../../components/AuthenticationDialog";

/**
 * Authenticated V2 chrome: left rail + page outlet. Isolated from
 * PunttLayout so tickets Documents never mount on ask.puntt.ai.
 *
 * The shared `AuthenticationDialog` IS mounted, even though the rest of
 * PunttLayout is not: V2's sidebar renders `<EnterpriseSwitcher/>`, and a
 * switch into an MFA-required enterprise parks its TOTP step in the store for
 * this dialog to render. Without the mount the switch silently does nothing.
 * It renders nothing while closed, so the V2 shell gains no chrome.
 */
export function AskV2Layout() {
  return (
    <div
      data-testid="ask-v2-shell"
      className="relative grid h-screen grid-cols-[auto_1fr] overflow-hidden bg-puntt-neutral-gray-2"
    >
      <AskPunttDesktopNotificationsWatcher />
      <AuthenticationDialog />
      <AskV2Sidebar />
      <div
        className="flex h-full min-h-0 min-w-0 flex-col overflow-hidden"
        data-testid="ask-v2-outlet-shell"
      >
        <Outlet />
      </div>
    </div>
  );
}
